angular.module('zc.zenclerkS')
  .controller('ZcsCampaignEditModalLaunchController', ZcsCampaignEditModalLaunchController);

ZcsCampaignEditModalLaunchController.$inject = ['$state', '$uibModalInstance', 'ZcsCampaign', 'campaign', 'isIntegratedWithMakeshop', 'project'];
function ZcsCampaignEditModalLaunchController($state, $uibModalInstance, ZcsCampaign, campaign, isIntegratedWithMakeshop, project) {
  /* Init */
  const vm = this;

  /* Scopes */
  vm.project = project;
  vm.isIntegratedWithMakeshop = isIntegratedWithMakeshop;
  vm.campaign = campaign;
  vm.close = close;
  vm.launch = launch;
  vm.saveInProgressOrSucceeded = false;
  vm.$onInit = () => {
    vm.isAllowedToCreate = () => ZcsCampaign.isAllowedToCreate(vm.project);
    vm.getTooltipMessage = () => ZcsCampaign.getTooltipMessage(vm.project);
  };

  function launch() {
    if(!ZcsCampaign.isAllowedToCreate(vm.project)) {
      return false;
    }

    // set ready for launching
    vm.campaign.status = 'activated';

    // There's probably a possibility of state.go taking too long time
    // that the button will be active for few ms, and user might click it two times.
    vm.saveInProgressOrSucceeded = true;
    ZcsCampaign.save(vm.campaign, vm.project)
      .then(res => {
        $state.go('zenclerkS.project.campaigns.active', {apikey: vm.project.apikey});
        close();
      })
      .catch(err => {
        vm.saveInProgressOrSucceeded = false;
      });

  }

  function close() {
    $uibModalInstance.close();
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/edit/campaign_edit_modal_launch.controller.js